import { injectable } from "tsyringe";
import { DISTRICT_CONFIGURATION } from "api/ApiPath";
import client from "api/client";
import { IDistrictConfigurationRepository } from "../domain/repositories/IDistrictConfigurationRepository";
import { DistrictConfigurationListRequestModel } from "./model/DistrictConfigurationListRequestModel";
import { DistrictConfigurationFormRequestModel } from "./model/DistrictConfigurationFormRequestModel";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { DistrictConfigurationResponseEntity } from "../domain/entities/DistrictConfigurationResponseEntity";

@injectable()
export class DistrictConfigurationImpl implements IDistrictConfigurationRepository {
  async getList(
    params: DistrictConfigurationListRequestModel,
  ): Promise<ListBaseApiResponseModel<DistrictConfigurationResponseEntity>> {
    return await client.get(DISTRICT_CONFIGURATION.LIST, params);
  }

  async getDetail(params: {
    id: string;
  }): Promise<BaseApiResponseModel<DistrictConfigurationResponseEntity>> {
    return await client.get(DISTRICT_CONFIGURATION.DETAIL, params);
  }

  async create(
    body: DistrictConfigurationFormRequestModel,
  ): Promise<BaseApiResponseModel<DistrictConfigurationResponseEntity>> {
    return await client.post(DISTRICT_CONFIGURATION.CREATE, body);
  }

  async update(
    body: DistrictConfigurationFormRequestModel,
  ): Promise<BaseApiResponseModel<DistrictConfigurationResponseEntity>> {
    return await client.put(DISTRICT_CONFIGURATION.UPDATE, body);
  }

  async delete(params: {
    id: string;
  }): Promise<BaseApiResponseModel<DistrictConfigurationResponseEntity>> {
    return await client.delete(DISTRICT_CONFIGURATION.DELETE, params);
  }
}
